(function () {
  const PAGE_WRAPPER_SELECTOR = '.page-wrapper';
  const SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');

  function getIntersectionRoot() {
    if (SQUEEZE_QUERY.matches) {
      return document.querySelector(PAGE_WRAPPER_SELECTOR) ?? null;
    }
    return null;
  }

  const SELECTORS = '.section, .product-card, figure, h1, h2, h3, h4, h5, h6, .rte, .banner, .card';

  const CSS = `
    .scroll-reveal-init {
      opacity: 0;
      transform: translateY(40px);
      transition: opacity 0.9s ease, transform 0.9s ease;
    }
    .scroll-reveal-init.scroll-reveal-visible {
      opacity: 1;
      transform: translateY(0);
    }
  `;

  function injectStyles() {
    if (document.getElementById('scroll-reveal-styles')) return;
    const style = document.createElement('style');
    style.id = 'scroll-reveal-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function initObserver() {
    const root = getIntersectionRoot();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: root, rootMargin: '0px 0px -40px 0px', threshold: 0.05 }
    );

    document.querySelectorAll(SELECTORS).forEach((el) => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < vh * 0.85) return;
      el.classList.add('scroll-reveal-init');
      observer.observe(el);
    });
  }

  function init() {
    injectStyles();
    requestAnimationFrame(() => setTimeout(initObserver, 200));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
